export default "__VITE_ASSET__120d710e__"